// extracted by mini-css-extract-plugin
module.exports = {"container":"foundInfo_container__aYWSW","header":"foundInfo_header__2O1Bk","title":"foundInfo_title__1MYHe","btn":"foundInfo_btn__XIy9-","block":"foundInfo_block__t7BjX"};